export default __webpack_public_path__ + "static/media/tile.06b613f3.svg";